<button
    type="button"
    class="settings-button"
    [pTooltip]="'SystemTools' | localize"
    tooltipPosition="top"
    (click)="toggle($event)"
>
    <i class="pi pi-cog"></i>
</button>

<p-overlayPanel #menuPanel styleClass="footer-settings-overlay" [showCloseIcon]="false" [dismissable]="true">
    <ng-template pTemplate>
        <ul class="settings-menu">
            <li>
                <button type="button" class="menu-item" (click)="clearCache()">
                    <i class="pi pi-trash"></i>
                    <span>{{ 'ClearCachedData' | localize }}</span>
                </button>
            </li>
        </ul>
    </ng-template>
</p-overlayPanel>
